export default "__VITE_ASSET__fdUGybc4__"